import END_POINTS from "consts/endPoints";
import axios from "./axios";

export const setUserLogin = () => {
  return axios.post(END_POINTS.AUTH_SET_LOGIN);
};

export const getCurrentUser = () => {
  return axios.get(END_POINTS.GET_CURRENT_USER);
};

export const exportFile = (data: any) => {
  return axios.post('api/Article/ExportArticles', data, { responseType: 'blob' });
};
